export function request(id, bets, channel) {
    id = parseInt(id, 10);

    return (dispatch, getState) => {
        dispatch({
            type: 'BETSLIP_OFFER_REFERRED_REQUEST',
            bets,
            channel,
            id,
            selections: getState().selections.get('items')
        });
    };
}

export function error(id, errors) {
    id = parseInt(id, 10);

    return {
        type: 'BETSLIP_OFFER_REFERRED_ERROR',
        errors,
        id
    };
}

export function finish(id, result) {
    id = parseInt(id, 10);

    return {
        type: 'BETSLIP_OFFER_REFERRED_FINISH',
        result,
        id
    };
}

export function clear() {
    return {
        type: 'BETSLIP_OFFER_REFERRED_CLEAR'
    };
}
